import { __assign } from "tslib";
import React, { forwardRef, useRef } from 'react';
import { cn } from '@bem-react/classname';
import { useButton } from '@use-platform/react/semantic/button';
import { useForwardedRef } from '@use-platform/react/libs/forward-ref';
import { Badge } from '../Badge';
import { Avatar } from '../Avatar';
import './User.css';
var userCn = cn('UserID', 'Wrapper');
export var UserBase = forwardRef(function (_a, ref) {
    var _b = _a.tld, tld = _b === void 0 ? 'ru' : _b, _c = _a.tabIndex, tabIndex = _c === void 0 ? 0 : _c, children = _a.children, env = _a.env, colorScheme = _a.colorScheme, userData = _a.userData, onClick = _a.onClick, onPointerEnter = _a.onPointerEnter, className = _a.className, fetchMail = _a.fetchMail, visible = _a.visible, ariaLabel = _a.ariaLabel, avatarSize = _a.avatarSize, platform = _a.platform;
    var _d = userData || {}, child = _d.child, plus = _d.plus, avatarId = _d.avatarId;
    var accountButtonRef = useRef(null);
    var userAccountAriaLabel = ariaLabel || 'Ваш профиль';
    useForwardedRef(accountButtonRef, ref);
    var buttonProps = useButton({
        'aria-haspopup': true,
        'aria-expanded': visible,
        'aria-label': userAccountAriaLabel,
        tabIndex: tabIndex,
        onPress: onClick,
    }, accountButtonRef).buttonProps;
    return (React.createElement("div", { className: userCn({ child: child }, [className]), style: { '--user-id-size': (avatarSize || 42) + "px" } },
        React.createElement("button", __assign({ className: "UserID-Account", ref: accountButtonRef }, buttonProps, { onPointerEnter: onPointerEnter }),
            React.createElement(Badge, { fetchMail: fetchMail && env !== 'test', tld: tld, hideCounter: platform === 'touch' },
                React.createElement(Avatar, { host: env === 'test' ? 'https://avatars.mdst.yandex.net' : 'https://avatars.mds.yandex.net', avatarId: avatarId, plus: plus, child: child, colorScheme: colorScheme }))),
        children));
});
UserBase.displayName = 'UserBase';
